import React from 'react'

const Ellipse = ({ className }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 11C22 8.82441 21.3549 6.69767 20.1462 4.88873C18.9375 3.07979 17.2195 1.66989 15.2095 0.837325C13.1995 0.00476117 10.9878 -0.213076 8.85401 0.211362C6.72022 0.635799 4.7602 1.68345 3.22183 3.22183C1.68345 4.7602 0.635799 6.72022 0.211362 8.85401C-0.213076 10.9878 0.0047612 13.1995 0.837325 15.2095C1.66989 17.2195 3.07979 18.9375 4.88873 20.1462C6.69767 21.3549 8.82441 22 11 22V19.8C9.25952 19.8 7.55813 19.2839 6.11098 18.3169C4.66383 17.35 3.53591 15.9756 2.86986 14.3676C2.20381 12.7596 2.02954 10.9902 2.36909 9.28321C2.70864 7.57617 3.54676 6.00816 4.77746 4.77746C6.00816 3.54676 7.57617 2.70864 9.28321 2.36909C10.9902 2.02954 12.7596 2.20381 14.3676 2.86986C15.9756 3.53591 17.35 4.66383 18.3169 6.11098C19.2839 7.55813 19.8 9.25952 19.8 11H22Z"
      fill="#A3B3C6"
    />
  </svg>
)

export default Ellipse
